import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import SeoManager from "./components/SeoManager";
import Home from "./pages/Home";
import CampamentoVerano from "./pages/CampamentoVerano";
import CampamentoUrbano from "./pages/CampamentoUrbano";
import EncuentroAdultos from "./pages/EncuentroAdultos";
import CursosEspecializados from "./pages/CursosEspecializados";
import ExtraescolarDetalle from "./pages/ExtraescolarDetalle";
import FAQ from "./pages/FAQ";
import Contacto from "./pages/Contacto";
import Preinscripcion from "./pages/Preinscripcion";
import Legal from "./pages/Legal";
import Equipo from "./pages/Equipo";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";

const ADMIN_PANEL_PATH = process.env.REACT_APP_ADMIN_PANEL_PATH || "/acceso-reservado-dac-7f3a9";

function AppLayout() {
  const location = useLocation();
  const isAdminRoute = location.pathname === ADMIN_PANEL_PATH || location.pathname === "/admin";

  return (
    <div className="App">
      <SeoManager />
      <ScrollToTop />
      {!isAdminRoute ? <Navbar /> : null}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/campamento-verano" element={<CampamentoVerano />} />
        <Route path="/campamento-verano/campamento-urbano" element={<CampamentoUrbano />} />
        <Route path="/campamento-verano/turno-julio" element={<Navigate to="/campamento-verano" replace />} />
        <Route path="/campamento-verano/turno-agosto" element={<Navigate to="/campamento-verano" replace />} />
        <Route path="/encuentro-adultos" element={<EncuentroAdultos />} />
        <Route path="/cursos-especializados" element={<CursosEspecializados />} />
        <Route path="/cursos-especializados/:slug" element={<ExtraescolarDetalle />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/preinscripcion" element={<Preinscripcion />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/equipo" element={<Equipo />} />
        <Route path={ADMIN_PANEL_PATH} element={<Admin />} />
        <Route path="/admin" element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isAdminRoute ? <Footer /> : null}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;
